import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";
import MeshBg from "@/components/MeshBg";
import Blocks from "@/components/Blocks";
import Gallery from "@/components/Gallery";
import { CAMPANII, ASSETS } from "@/data/content";

export default function CampaniiCustom() {
  const c = CAMPANII;
  return (
    <div data-testid="campanii-custom-page">
      {/* HERO */}
      <section className="relative overflow-hidden pt-16 md:pt-24 pb-12 md:pb-16 border-b border-slate-100">
        <MeshBg />
        <div className="container-x grid gap-12 lg:grid-cols-2 lg:items-center">
          <div>
            <Reveal>
              <span className="overline">{c.kicker}</span>
            </Reveal>
            <Reveal delay={0.05}>
              <h1 className="mt-5 text-4xl md:text-6xl font-extrabold tracking-tight leading-[1.05]">
                {c.title}
              </h1>
            </Reveal>
            <Reveal delay={0.1}>
              <div className="mt-7 max-w-xl space-y-4">
                {c.intro.map((p, i) => (
                  <p key={i} className="lead">
                    {p}
                  </p>
                ))}
              </div>
            </Reveal>
          </div>
          <Reveal delay={0.15}>
            <div className="relative mx-auto max-w-md lg:max-w-none">
              <div className="absolute -inset-3 -z-10 rounded-[2.2rem] bg-gradient-to-tr from-indigo-100 to-emerald-100 blur-lg" />
              <img
                src={ASSETS.customHero}
                alt=""
                className="w-full rounded-[1.6rem] object-cover shadow-[0_40px_80px_-40px_rgba(15,23,42,0.4)]"
              />
            </div>
          </Reveal>
        </div>
      </section>

      {/* HOW */}
      <section className="py-14 md:py-18">
        <div className="container-x max-w-3xl">
          <Reveal>
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight">{c.how.title}</h2>
            <div className="mt-6 space-y-4">
              {c.how.body.map((p, i) => (
                <p key={i} className="text-slate-600 leading-relaxed text-[17px]">
                  {p}
                </p>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      {/* ACTIONS */}
      <section className="bg-white py-12 md:py-16 border-y border-slate-100">
        <div className="container-x space-y-14 md:space-y-20">
          {c.actions.map((a, i) => {
            const reversed = i % 2 === 1;
            return (
              <div key={a.index} className="grid gap-10 lg:grid-cols-2 lg:items-center">
                <Reveal className={reversed ? "lg:order-2" : ""}>
                  <div className="flex items-baseline gap-4">
                    <span className="font-display text-5xl md:text-6xl font-extrabold text-slate-200">
                      {a.index}
                    </span>
                    <div>
                      <h3 className="text-2xl md:text-3xl font-bold tracking-tight">{a.title}</h3>
                      <p className="mt-1 font-display font-medium text-brand">{a.subtitle}</p>
                    </div>
                  </div>
                  <Blocks items={a.body} className="mt-6" />
                </Reveal>
                <Reveal delay={0.1} className={reversed ? "lg:order-1" : ""}>
                  <Gallery images={a.gallery} testid={`campanie-gallery-${i}`} />
                </Reveal>
              </div>
            );
          })}
        </div>
      </section>

      {/* CTA */}
      <section className="py-12 md:py-16">
        <div className="container-x">
          <Reveal>
            <div className="relative overflow-hidden rounded-[2rem] bg-ink px-8 py-14 md:px-16 md:py-20 text-center">
              <div className="pointer-events-none absolute -top-16 left-1/4 h-64 w-64 rounded-full bg-brand/40 blur-3xl" />
              <div className="pointer-events-none absolute -bottom-16 right-1/4 h-64 w-64 rounded-full bg-leaf/25 blur-3xl" />
              <h2 className="relative mx-auto max-w-2xl text-3xl md:text-5xl font-extrabold tracking-tight text-white">
                {c.cta}
              </h2>
              <div className="relative mt-8">
                <Link to="/contact" data-testid="campanii-cta" className="btn px-8 py-4 bg-white text-ink hover:scale-[1.03]">
                  Contactează-ne
                </Link>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
